/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable array-callback-return */
import {MetabaseDashboard} from "../ui/report/MetabaseDashboardListView";
import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";

export const MENU_SERVICE_NAME = "menuService";

export class PermissionCategory {
    static METRICS = "";
    static USERS = "USERS";
    static TEST = "TEST";
    static DASHBOARD_USER_GROUPS = "DASHBOARD_USER_GROUPS";
    static ACHIEVEMENTS = "ACHIEVEMENTS";
    static WALLET = "WALLET";
    static POKER_TOURNAMENTS = "POKER_TOURNAMENTS";
    static POKER_TABLES = "POKER_TABLES";
    static ADMIN_DASHBOARD_USERS = "ADMIN_DASHBOARD_USERS";
    static LEADERBOARD = "LEADERBOARD";
    static BONUS = "BONUS";
    static OPERATOR_PROGRESSION = "OPERATOR_PROGRESSION";
    static ITEMS = "ITEMS";
    static OPERATOR = "OPERATOR";
    static EVENTS = "EVENTS";
    static DASHBOARD_AUTHENTICATION = "DASHBOARD_AUTHENTICATION";
    static HAND_HISTORY = "HAND_HISTORY";
    static ANALYZER = "ANALYZER";
    static POKER_SYSTEM_MANAGEMENT = "POKER_SYSTEM_MANAGEMENT";
    static CASINO = "CASINO";
    static CHAT = "CHAT";
    static STORE = "STORE";
    static TRANSLATIONS = "TRANSLATIONS";
    static BATCH_WALLET = "BATCH_WALLET";
    static USER_AUTHENTICATION = "USER_AUTHENTICATION";
}


export interface MenuRouteGroup {
    id?: string;
    name?: string;
    routes?: MenuRoute[];
    hideTitle?: boolean;
    icon?: string;
}

export interface MenuRoute {
    path?: string,
    label: string,
    icon?: string;
    displayInMenu?: boolean;
    children?: MenuRoute[];
    writeAccess?: boolean;
    permissions?: string[];
    externalLink?: boolean;
}

export interface RequiresPermission {
    category: string;
    requiresWriteAccess: boolean;
}

function intersects(arrA: string[], arrB: string[]): boolean {
    if (arrA == null || arrB == null) {
        return false;
    }
    return arrA.some(a => {
        return typeof (arrB.find(b => b === a)) != "undefined";
    });
}

let filterRoutes = function (routes?: MenuRoute[], permissions?: { [p: string]: boolean }): any {
    if (!routes) {
        return null;
    }
    return routes.filter((route: MenuRoute) => {
        var permitted = hasPermission(route.permissions, route.writeAccess, permissions);
        return permitted;
    }).map(route => {
        return Object.assign({}, route, {children: filterRoutes(route.children, permissions)});
    });
};


export class MenuService extends AbstractAdminEntityService<any, any> {
    routes: Array<MenuRouteGroup> = [];

    addGroup(name: string, hideTitle: boolean, icon: string, routes: MenuRoute[]) {
        this.routes.push({
            name: name,
            id: name,
            hideTitle: hideTitle,
            routes: routes,
            icon: icon
        });
    }

    constructor(http: HttpService) {
        super("", http);

    }

    async getMetabaseDashboardList(): Promise<MetabaseDashboard[]> {
        return this.http.get('/metabase/dashboards')
    }

    async getMetabaseCardsList(): Promise<MetabaseDashboard[]> {
        return this.http.get('/metabase/cards')
    }

    async getMenuRoutes(permissions: { [key: string]: boolean }): Promise<MenuRouteGroup[]> {
        var routes = this.getRoutes(permissions);
        return routes;
    }

    isDisplayInMenu(route: any): boolean {
        return typeof (route.displayInMenu) == "undefined" || route.displayInMenu === true
    }

    async getRoutes(permissions: { [key: string]: boolean }): Promise<MenuRouteGroup[]> {
        let metabaseDashboardPaths: any = [];
        let metabaseReportsPaths: any = [];
        try {
            await this.getMetabaseDashboardList().then((dashboard: any) => {
                if (dashboard.length > 0) {
                    dashboard.map((dboard: MetabaseDashboard) => {
                        metabaseDashboardPaths.push({path: `/metabase/dashboard/${dboard.id}`, label: dboard.name})
                    })
                }
            });
        } catch (e) {
            console.log("Failed to load dashboards from metabase.")
        }
        try {
            await this.getMetabaseCardsList().then((cards: any) => {
                if (cards.length > 0) {
                    cards.map((card: any) => {
                        metabaseReportsPaths.push({path: `/metabase/report/${card.id}`, label: card.name})
                    })
                }
            });
        } catch (e) {
            console.log("Failed to load dashboards from metabase.")
        }

        this.routes = [];
        this.addGroup("Dashboards", true, "shop-4", [
            {path: '/', icon: "airplay", label: "Home"}
        ]);
        this.addGroup("Integrations", true, "shop-4", [
            {path: '/integrations', icon: "grid", label: "Integrations"}
        ]);

        this.addGroup("User Management", false, "air-balloon-1", [
            {
                icon: "user", label: "Users",
                children: [
                    {path: "/users", label: "List Users"},
                    {path: "/user/batch/actions", label: "User Batch Actions"}
                ]
            },
            {
                icon: "message-circle", label: "Tickets",
                children: [
                    { path: "/tickets/list", label: "List Tickets" },
                    { path: "/tickets/new", label: "Create Ticket" }
                ]
            },
            {
                icon: "tag", label: "User Attributes",
                children: [
                    {path: "/user-attributes", label: "List Attributes"},
                    {path: "/user-attribute/new", label: "Create Attribute"}
                ]
            },
            {
                icon: "message-circle", label: "Push Notification",
                children: [
                    {path: "/notifications", label: "Send Notification"},
                ]
            },
            {
                icon: "tag", label: "User Tags",
                children: [
                    {path: "/user-labels/list", label: "List"},
                    {path: "/user-label/new", label: "Create"}
                ]
            }
        ]);


        this.addGroup("Bonus", false, "shop-4", [
            {
                icon: "grid", label: "User Bonus Offers",
                children: [
                    {path: '/bonus/offers/list', label: "List Offers"},

                ]
            },
            {
                icon: "grid", label: "Bonus Configs",
                children: [
                    {path: '/bonus/configs/list', label: "List"},
                    {path: '/bonus/config/new', label: "Create"},

                ]
            },
            {
                icon: "grid", label: "Contributions",
                children: [
                    {path: '/bonus/turnover-contribution/list', label: "List"},
                    {path: '/bonus/turnover-contributions/new', label: "Create"},

                ]
            },
            {
                icon: "grid", label: "Monetary Config",
                children: [
                    {path: '/bonus/monetary-configs/list', label: "List"},
                    {path: '/bonus/monetary-config/new', label: "Create"},

                ]
            },
            {
                icon: "grid", label: "Triggers",
                children: [
                    {path: '/bonus/offer-rules/list', label: "List"},
                    {path: '/bonus/offer-rule/new', label: "Create"},

                ]
            },
            {
                icon: "grid", label: "Settings",
                children: [
                    {path: '/bonus/setting-limits/list', label: "List Limits"},
                    {path: '/bonus/setting-limit/new', label: "Create Limit"},

                ]
            }
        ]);

        this.addGroup("Analytics", false, "shop-4", [
            {path: '/analytics/amplitude', icon: "bar-chart-2", label: "Amplitude", externalLink: true},
            {
                icon: "clipboard", label: "Player Audit Logs",
                children: [
                    {path: "/analytics-logs", label: "List"},
                ]
            },
        ]);

        this.addGroup("Payments", false, "air-balloon-1", [
            {
                icon: "dollar-sign", label: "Payments",
                children: [
                    {path: "/payments/list", label: "List Payments"},
                    {path: "/payment/new", label: "Create Payment Deposit"}
                ]
            },
            {
                icon: "settings", label: "Payment Settings",
                children: [
                    {path: "/payment-settings/list", label: "List Payment Settings"}
                ]
            }
        ]);

        this.addGroup("Casino", false, "air-balloon-1", [
            {
                icon: "list", label: "Casino Lobby",
                children: [
                    {path: "/casino-categories", label: "List Categories"},
                    {path: "/casino-category/new", label: "Create Category"}
                ]
            },
            {
                icon: "tv", label: "Casino Games",
                children: [
                    {path: "/casino-games", label: "List Games"}
                ]
            },
            {
                icon: "video", label: "Casino Studios",
                children: [
                    {path: "/casino-studios", label: "List Studios"}
                ]
            },
            {
                icon: "tag", label: "Game Tags",
                children: [
                    {path: "/casino-game-tags", label: "List Tags"},
                    {path: "/casino-game-tag/new", label: "Create Tag"}
                ]
            }
        ]);

        this.addGroup("Contests", false, "air-balloon-1", [
            {
                icon: "list", label: "Contests",
                children: [
                    {path: "/contests/list", label: "List Contests"}
                ]
            },
            {
                icon: "list", label: "Contest Types",
                children: [
                    {path: "/contest-types/list", label: "List Contest Types"}
                ]
            }
        ]);

        this.addGroup("Sportsbetting", false, "air-balloon-1", [
            {
                icon: "list", label: "Bets",
                children: [
                    {path: "/sportsbetting/bets/list", label: "List Bets"}
                ]
            },
            {
                icon: "list", label: "Bet Logs",
                children: [
                    {path: "/sportsbetting/bet-logs/list", label: "List Bet Logs"}
                ]
            }
        ]);

        this.addGroup("Affiliate Management", false, "air-balloon-1", [
            {
                icon: "tag", label: "Affiliates",
                children: [
                    {path: "/affiliates", label: "List"},
                    {path: "/affiliates/settings", label: "Settings"}
                ]
            },
            {
                icon: "list", label: "Affiliate Reports",
                children: [
                    {path: "/affiliates/reports/revenue", label: "Revenue"},
                    {path: "/affiliates/reports/payouts", label: "Payouts"},
                ]
            }
        ]);

        /**this.addGroup("Store", false, "shopping-cart", [
            {
                icon: "shopping-cart", label: "Bundles",
                children: [
                    {path: "/bundles", label: "List Bundles"},
                    {path: "/bundles/new", label: "Create Bundle"}
                ]
            },
        ]);*/

        this.addGroup("Translations", false, "shopping-cart", [
            {
                icon: "file-text", label: "Translations",
                children: [
                    {path: "/translations", label: "List translations"}
                ]
            },
        ]);

        this.addGroup("Accounting", false, "air-balloon-1", [
            {
                icon: "clipboard", label: "Accounts",
                children: [
                    {path: "/accounts", label: "List"},
                    {path: "/account/edit/new", label: "Create"}
                ]
            },
            {
                icon: "dollar-sign", label: "Currencies",
                children: [
                    {path: "/currencies/list", label: "List"},
                    {path: "/currencies/edit/new", label: "Create"}
                ]
            },
            /*{
                icon: "dollar-sign", label: "Batch Transactions",
                children: [
                    {path: "/create-batch", label: "Show & Create Batches"}
                ]
            },*/
            {
                icon: "clipboard", label: "Credits",
                children: [
                    {path: "/credits", label: "List Credits"},
                    {path: "/credit/new", label: "Create Credit"}
                ]
            }


        ]);

        this.addGroup("Audit", false, "air-balloon-1", [
            {
                icon: "clipboard", label: "Audit Logs",
                children: [
                    {path: "/audit-logs", label: "List"},
                    {path: "/audit-logs-admin-user-login", label: "Admin User Login"},
                    {path: "/audit-logs-bonus-update", label: "Bonus Update"},
                    {path: "/audit-logs-manual-balance-adjustment", label: "Manual Balance Adjustment"},
                    {path: "/audit-logs-manual-bonus-award", label: "Manual Bonus Award"},
                    {path: "/audit-logs-payment-update", label: "Payment Update"},
                    {path: "/audit-logs-player-update", label: "Player Update"},
                    {path: "/audit-logs-player-product-update", label: "Player Product Update"},
                    {path: "/audit-logs-player-mfa-disabled", label: "Player MFA Disabled"},
                    {path: "/audit-logs-player-blocked-update", label: "Player Blocked Update"}
                ]
            },
            {
                icon: "clipboard", label: "System Events",
                children: [
                    {path: "/system-events", label: "List"},
                ]
            }
        ]);

        this.addGroup("Admin", false, "air-balloon-1", [
            {
                icon: "user", label: "Admin Users",
                children: [
                    {path: "/admin/admin-users", label: "List Admins"},
                    {path: "/admin/admin-user/new", label: "Create Admin"}
                ]
            },
            {
                icon: "users", label: "User Groups",
                children: [
                    {path: "/admin/user-groups", label: "List Groups"},
                    {path: "/admin/user-group/new", label: "Create Group"}
                ]
            },
            {
                icon: "settings", label: "Settings",
                children: [
                    {path: "/admin/settings/general", label: "General"},
                    {path: "/admin/settings/transferLimits", label: "Transfer Limits"},
                    {path: "/admin/settings/integrations", label: "Integrations"},
                    {path: "/admin/settings/user", label: "User"},
                    {path: "/admin/settings/internal", label: "Internal"},
                    {path: "/admin/settings/pwa", label: "PWA"},
                    {path: "/admin/settings/notifications", label: "Push Notifications"}
                ]
            }
        ]);
        this.addGroup("Guides", false, "air-balloon-1", [
            {
                icon: "image", label: "Styling",
                children: [
                    {path: "/guides/styling", label: "CSS Styling Guide"},
                    {path: "/guides/cms", label: "Content/CMS"}
                ]
            }
        ]);


        try {
        } catch (e) {

        }
        return this.routes;
        /*
        return this.routes.map( (g : MenuRouteGroup) => {
             let routes = filterRoutes(g.routes, permissions)
            return Object.assign({}, g, { routes : routes});
        }).filter( (g : MenuRouteGroup) => g.routes && g.routes.length  > 0);
*/
    }

}


function hasPermission(categories?: string[], requiresWriteAccess?: boolean, permissions?: { [key: string]: boolean }) {
    if (!categories || categories.length === 0) {
        return true;
    }
    if (!permissions) {
        return false;
    }
    if (typeof (requiresWriteAccess) == "undefined") {
        requiresWriteAccess = false;
    }

    /*
    if(!intersects(categories, AppCtx.getEnabledPermissionCategories())) {
        return false;
    }*/


    return categories.some(cat => {
        var writeAccess = permissions[cat];
        if (typeof (writeAccess) != "undefined") {
            if (writeAccess === true && requiresWriteAccess === true) {
                return true;
            } else if (requiresWriteAccess === false) {
                return true;
            }
        }
        return false;
    });
}
